/* ==========================================================================
   Parker & Rose — staffelbalk verbergen in winkelwagens met een eigen aanbod
   --------------------------------------------------------------------------
   Waarom dit bestaat: producten met een bundelaanbod (1+1 en varianten) vallen
   buiten de staffelkortingen. UpCart telt ze ook niet mee, maar blijft wél zijn
   balk tonen: "You're 2 products away from 15% OFF!". Die belofte komt niet uit
   — de bundelkorting is groter en jouw kortingen combineren niet, dus Shopify
   kiest de bundel en die 15% valt nooit toe. In zo'n winkelwagen hoort die balk
   dus weg.

   Waarom het geen gewone CSS in pr-custom.css is: UpCart rendert zijn drawer in
   een shadow root op #upCart. Stylesheets van de pagina komen daar niet binnen
   (nagemeten: document.querySelector('.upcart-public-rewards') geeft null).
   De enige route is een <style> ín die shadow root zetten, en dat kan alleen
   met JavaScript.

   Afhankelijkheid van buitenaf: de klasse .upcart-public-rewards. Het voorvoegsel
   "public" is UpCart's eigen aanduiding voor haken waar winkeliers op mogen
   stylen, dus dit is de stabielste keuze die er is. Verandert UpCart hem toch,
   dan verschijnt de balk gewoon weer — hij breekt zichtbaar, niet stil.
   ========================================================================== */

(function () {
  'use strict';

  var STYLE_ID = 'pr-offer-hide-rewards';
  var CSS = '.upcart-public-rewards,.upcart-internal-rewards{display:none!important}';

  var data = document.getElementById('pr-offer-products');
  var offerIds = [];
  try {
    offerIds = JSON.parse(data.textContent) || [];
  } catch (e) {
    return;
  }
  if (!offerIds.length) return;

  var shouldHide = false;
  var watching = false;

  function shadow() {
    var host = document.getElementById('upCart');
    return host ? host.shadowRoot : null;
  }

  function apply() {
    var sr = shadow();
    if (!sr) return;

    var existing = sr.querySelector('#' + STYLE_ID);

    if (shouldHide && !existing) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      sr.appendChild(style);
    } else if (!shouldHide && existing) {
      existing.remove();
    }

    /* UpCart bouwt zijn drawer opnieuw op bij elke wijziging en gooit dan alles
       weg wat er niet van hem is. Daarom blijven we meekijken en zetten we hem
       er zo nodig opnieuw in. */
    if (!watching) {
      watching = true;
      new MutationObserver(function () { apply(); })
        .observe(sr, { childList: true, subtree: false });
    }
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        shouldHide = (cart.items || []).some(function (item) {
          return offerIds.indexOf(item.product_id) > -1;
        });
        apply();
      })
      .catch(function () { /* winkelwagen niet leesbaar: balk gewoon laten staan */ });
  }

  /* De drawer bestaat pas zodra UpCart geladen is. */
  var tries = 0;
  var wait = setInterval(function () {
    tries++;
    if (shadow()) { clearInterval(wait); refresh(); }
    else if (tries > 40) { clearInterval(wait); }
  }, 250);

  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added',
   'product:added-to-cart', 'cart-drawer:open', 'pr:cart'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });

  /* UpCart's eigen haak. Nodig omdat het verwijderen van de laatste
     aanbodregel uit de drawer geen van de events hierboven afvuurt: zonder
     dit bleef de balk verborgen terwijl hij weer had moeten verschijnen.
     Een bestaande functie van iemand anders blijft gewoon werken. */
  ['upcartOnCartUpdated', 'upcartOnCartLoaded', 'upcartOnAddToCart'].forEach(function (hook) {
    var vorige = window[hook];
    window[hook] = function () {
      if (typeof vorige === 'function') {
        try { vorige.apply(this, arguments); } catch (e) { /* niet onze fout, niet ons probleem */ }
      }
      refresh();
    };
  });

  /* UpCart zet upcartPopupShow op <body> bij openen; goed moment om te hertoetsen. */
  new MutationObserver(function () { refresh(); })
    .observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
  window.addEventListener('pageshow', refresh);
})();
